module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/BIOLOGY-531b1b742a83dff0209c3fcbda86ee18.png";